import { render, staticRenderFns } from "./NoResults.vue?vue&type=template&id=9625e412&scoped=true"
import script from "./NoResults.vue?vue&type=script&lang=js"
export * from "./NoResults.vue?vue&type=script&lang=js"
import style0 from "./NoResults.vue?vue&type=style&index=0&id=9625e412&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9625e412",
  null
  
)

export default component.exports